import { render, staticRenderFns } from "./FeedAlertTimeExceed.vue?vue&type=template&id=4e807731"
import script from "./FeedAlertTimeExceed.vue?vue&type=script&lang=js"
export * from "./FeedAlertTimeExceed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports